import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

// Assets
import EmptyState from "assets/empty-state-buyer-match.png";
import IEmptyArchived from "assets/empty-state-list-archived.png";
import ICarret from "assets/i-carret.js";
import IInfo from "assets/i-info.js";
import IX from "assets/i-x.js";

// Components
import Button from "components/v1/Button";
import ModalLoader from "components/organism/ModalLoader";

const widthContainer = 1167;

const PrimarySize = {
  no: 32,
  customerName: 200,
  whatsapp: 200,
  saranListing: 80,
  tipeProperty: 80,
  tipeListing: 80,
  belumDinilai: 80,
  tertarik: 80,
  action: 95,
};

// Class
const headerRowClassName =
  "flex items-center px-4 py-2 gap-[24px] bg-[#FaFaFa] border-b-[1px] border-solid border-[#D8D8D9]";
const headerColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#808285]";

const bodyRowClassName =
  "flex items-center px-4 py-[10px] gap-[24px] border-b-[0.5px] border-solid border-[#D8D8D9]";
const bodyColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter truncate";

const TableBuyer = ({ data, isLoading, handleOpenModal, setListCustomerParams, listCustomerParams, isSearch, totalPage }) => {
  const { pathname } = useLocation();
  const isArchived = pathname.includes("list-archived");

  const page = listCustomerParams.page;

  const _getSize = (size) => {
    return `${(size / widthContainer) * 100}%`;
  };

  const [showWarning, setShowWarning] = useState(data.length >= 10);

  const handlePrevPage = () => {
    setListCustomerParams({
      ...listCustomerParams,
      page: page - 1,
    });
  };

  const handleNextPage = () => {
    setListCustomerParams({
      ...listCustomerParams,
      page: page + 1,
    });
  };

  useEffect(() => {
    setShowWarning(data.length >= 10);
  }, [data]);

const renderMessage = useMemo(() => {
    let msg = {
      title: "",
      subtitle: "",
    };

    // List buyer search
    if (isSearch) {
      msg.title = "Customer Tidak Ditemukan";
      msg.subtitle =
        "Periksa kembali ejaan nama atau buat profil customer baru jika belum terdaftar.";

      return msg;
    }

    // List buyer
    if (!isSearch && !isArchived) {
      msg.title = "Belum ada profil customer";
      msg.subtitle =
        "Tambahkan profil customer untuk mulai menyesuaikan listing sesuai preferensi mereka.";

      return msg;
    }

    // List buyer archived
    if (!isSearch && isArchived) {
      msg.title = "Tidak Ada Arsip";
      msg.subtitle =
        "Belum ada customer yang Anda arsipkan. Customer yang diarsipkan akan ditampilkan di sini.";

      return msg;
    }

    return msg;
  }, [isSearch, isArchived]);

  return (
    <>
      <div className="rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9] min-w-[1149px]">
        {/* Header */}
        <div className={headerRowClassName}>
          <div style={{ width: _getSize(PrimarySize.no) }}>
            <span className={headerColClassName}>No.</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.customerName) }}>
            <span className={headerColClassName}>Nama Customer</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.whatsapp) }}>
            <span className={headerColClassName}>Nomor WhatsApp</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.saranListing) }}>
            <span className={headerColClassName}>Saran listing</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.tipeProperty) }}>
            <span className={headerColClassName}>Tipe Properti</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.tipeListing) }}>
            <span className={headerColClassName}>Tipe Listing</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.belumDinilai) }}>
            <span className={headerColClassName}>Belum dinilai</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.tertarik) }}>
            <span className={headerColClassName}>Tertarik</span>
          </div>
          <div style={{ width: _getSize(PrimarySize.action) }}>
            <span className={headerColClassName}>Action</span>
          </div>
        </div>

        {/* Info */}
       {showWarning && <div className="flex items-center justify-between gap-1 px-4 py-2 bg-[#F6E5B6]">
          <div className="flex items-center gap-1">
            <IInfo color="#614E1A" />
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] font-inter text-[#614E1A]">
              Batas 10 customer tercapai. Arsipkan atau hapus customer lama
              untuk menambah yang baru.
            </p>
          </div>
          <IX onClick={() => setShowWarning(false)} color="#614E1A" />
        </div>}

        {/* Body */}
        {data?.length ? (
          data.map((item, index) => (
            <div key={`table-buyer-${index}`} className={bodyRowClassName}>
              <div style={{ width: _getSize(PrimarySize.no) }}>
                <span className={bodyColClassName}>{index + 1}</span>
              </div>
              <div style={{ width: _getSize(PrimarySize.customerName) }}>
                <span className={bodyColClassName}>{item?.name}</span>
              </div>
              <div style={{ width: _getSize(PrimarySize.whatsapp) }}>
                <span className={bodyColClassName}>
                  {item?.whatsapp_number}
                </span>
              </div>
              <div style={{ width: _getSize(PrimarySize.saranListing) }}>
                <span className={`${bodyColClassName} ${parseInt(item?.count_listing_matched) > 0 ? "text-[#252526]" : "text-[#D8D8D9]"}`}>
                  {item?.count_listing_matched || "0"}
                </span>
              </div>
              <div style={{ width: _getSize(PrimarySize.tipeProperty) }}>
                <span className={bodyColClassName}>{item.type_property}</span>
              </div>
              <div style={{ width: _getSize(PrimarySize.tipeListing) }}>
                <span className={bodyColClassName + " capitalize"}>
                  {item?.type_listing?.replace("Di", "")}
                </span>
              </div>
              <div style={{ width: _getSize(PrimarySize.belumDinilai) }}>
                <span className={`${bodyColClassName} ${parseInt(item?.count_listing_sent) > 0 ? "text-[#252526]" : "text-[#D8D8D9]"}`}>
                  {item?.count_listing_sent || "0"}
                </span>
              </div>
              <div style={{ width: _getSize(PrimarySize.tertarik) }}>
                <span className={`${bodyColClassName} ${parseInt(item?.count_listing_interested) > 0 ? "text-[#252526]" : "text-[#D8D8D9]"}`}>
                  {item?.count_listing_interested || "0"}
                </span>
              </div>
              <div style={{ width: _getSize(PrimarySize.action) }}>
                <Button
                  icon={IInfo}
                  iconColor="#252526"
                  text="Detail"
                  type="secondary"
                  onClick={() => handleOpenModal(item?.id)}
                />
              </div>
            </div>
          ))
        ) : !data?.length && !isLoading ? (
          <div className="h-[494px] flex flex-col items-center justify-center gap-0.5 py-6">
            <img
              className="w-[48px] h-[48px] object-contain"
              src={isArchived ? IEmptyArchived : EmptyState}
              alt="empty-state"
            />
            <p className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#252526]">
              {renderMessage.title}
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] font-inter text-[#808285]">
              {renderMessage.subtitle}
            </p>
          </div>
        ) : null}
      </div>

      <div className="flex items-center justify-between mt-4 min-w-[1149px]">
        <p className="text-[11px]/[18px] italic font-inter text-[#808285]">
          *Menampilkan <span className="text-[#252526]">{data.length}</span>{" "}
          dari {data.length} data.
        </p>

        <div className="flex items-center gap-2">
          <button
            onClick={handlePrevPage}
            disabled={page === 1}
            className="rotate-180 w-6 h-6 border border-solid border-[#D8D8D9] rounded-[4px] flex items-center justify-center disabled:opacity-50"
          >
            <ICarret />
          </button>
          <span className="text-[11px]/[18px] font-semibold font-inter text-[#252526] w-6 h-6 rounded-[4px] flex items-center justify-center shadow-[0_0_2px_0_rgba(0,0,0,0.32)]">
            {page}
          </span>
          <button
            onClick={handleNextPage}
            disabled={page === totalPage}
            className="w-6 h-6 border border-solid border-[#D8D8D9] rounded-[4px] flex items-center justify-center disabled:opacity-50"
          >
            <ICarret />
          </button>
        </div>
      </div>

      <ModalLoader open={isLoading} />
    </>
  );
};

export default TableBuyer;
